import { createAsyncThunk } from "@reduxjs/toolkit";
import { getrequirementRequestByIdList } from "../../../../services/industryRequirement/industryRequirement";



export const getRequirementRequestListThunk = createAsyncThunk('/getRequirementRequestList',async(id)=>{
    const data = await getrequirementRequestByIdList(id)
    return data ;
})